import React, { useState } from "react";
import { PaymentElement, useElements, useStripe } from "@stripe/react-stripe-js";
import {
  Button,
  Paper,
} from "@mui/material";
import MDBox from "components/MDBox";
import { updatePaymentMethod } from "store/slice/customer/customerSlice";
import { useDispatch } from "react-redux";
import { getSubscriptionsList } from "store/slice/customer/customerSlice";

const UpdatePaymentMethod = ({
  setUpdateCard,
  setPaymentMethodEdit,
  subscriptionId,
  setSuccessMessage,
  clientSecret,
}) => {
  const stripe = useStripe();
  const elements = useElements({paymentMethodCreation: 'manual'});
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const handleUpdatePaymentMethod = (stripe, elements) => async (e) => {
    e.preventDefault();

    if (!stripe || !elements) {
      return;
    }

    setLoading(true);

    // Trigger form validation and wallet collection
    const {error: submitError, ...res} = await elements.submit();
    if (submitError) {
      setLoading(false);
      return;
    }
    const paymentMethodResponse = await stripe.createPaymentMethod({
      elements
    })

    const params = {
      subscriptionId: subscriptionId,
      paymentMethodId: paymentMethodResponse.paymentMethod.id,
      paymentMethodType:"ACH"
    };
    await dispatch(updatePaymentMethod(params))
      .unwrap()
      .then(async (result) => {
        if (result.success) {
          await dispatch(getSubscriptionsList());
          setUpdateCard(false);
          setPaymentMethodEdit(false);
          setSuccessMessage(true);
        } else {
          setLoading(false);
        }
      })
      .catch((err) => {
        setLoading(false);
        throw err;
      });

    setLoading(false);
  };

  return (
    clientSecret ?
      <div>
        <Paper variant="outlined" className="p-2" sx={{ py: 1.3, width: "100%" }}>
          <PaymentElement id="payment-element" />
        </Paper>

        <MDBox
          display="flex"
          justifyContent="end"
          gap={2}
          mt={2}
          className="text-center"
        >
          <Button
            color="white"
            variant="contained"
            size="small"
            onClick={handleUpdatePaymentMethod(stripe, elements)}
            disabled={loading}
          >
            Submit
          </Button>
          <Button
            color="white"
            variant="contained"
            size="small"
            onClick={() => {
              setUpdateCard(false);
              setPaymentMethodEdit(false);
            }}
          >
            Cancel
          </Button>
        </MDBox>
      </div>
    :
      <></>
  );
};

export default UpdatePaymentMethod;
